import React, { Component } from 'react';
import { Play, Shield, Eye, Clock, Users, CheckCircle, Star, ArrowRight, Phone, Mail, MapPin } from 'lucide-react';

class Concierge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFeature: 0,
      stats: [
    { number: '24/7', label: 'Guest Support Availability' },
    { number: '99.9%', label: 'System Uptime' },
    { number: '300+', label: 'Properties Supported' },
    { number: '<30s', label: 'Average Response Time' }
  ],
  features: [
    {
      icon: <Eye className="w-6 h-6" />,
      title: 'Real-Time Visitor Interaction',
      description: 'Professional remote concierge agents assist guests, vendors, and staff via live video support.'
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'AI-Assisted Visitor Management',
      description: 'Smart systems support concierge agents by recognizing patterns, automating processes, and enhancing efficiency.'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: '24/7 Virtual Assistance',
      description: 'Round-the-clock guest handling, ensuring no visitor is ever left unattended.'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Multi-Property Concierge',
      description: 'Centralized concierge management for residential or commercial sites.'
    }
  ],
  services: [
    {
      title: 'Remote Guest Management',
      description: 'Handle visitor access, deliveries, and appointments with professional oversight.',
      features: ['Live greeting via kiosk or screen', 'Delivery coordination', 'Guest registration', 'Visitor pass issuance']
    },
    {
      title: 'Smart Visitor Verification',
      description: 'AI verifies guest identities for secured yet convenient entry.',
      features: ['Face matching', 'ID scanning', 'Appointment matching']
    },
    {
      title: 'Mobile Concierge Tools',
      description: 'Control access and communicate with guests from any device.',
      features: ['App-based approvals', 'Remote guest unlock', 'Concierge chat interface']
    },
    {
      title: 'System Integration',
      description: 'Integrate concierge systems with property management software and access control solutions.',
      features: ['PMS/CRM integration', 'API-based workflows', 'Entry log sync', 'Smart intercoms']
    }
  ],
  testimonials: [
    {
      name: 'Sarah Johnson',
      company: 'Metro Apartments',
      rating: 5,
      text: 'The concierge support is seamless. Visitors are greeted quickly and everything feels very professional.'
    },
    {
      name: 'Michael Chen',
      company: 'Crest Towers',
      rating: 5,
      text: 'Impressive technology and great team. We don’t need an on-site receptionist anymore.'
    },
    {
      name: 'Lisa Rodriguez',
      company: 'Skyline Residences',
      rating: 5,
      text: 'It feels like luxury service on a smart budget. 24/7 concierge makes a real difference.'
    }
  ]
    };
  }

  componentDidMount() {
    // Auto-rotate features every 4 seconds
    this.featureInterval = setInterval(() => {
      this.setState(prevState => ({
        activeFeature: (prevState.activeFeature + 1) % prevState.features.length
      }));
    }, 4000);
  }

  componentWillUnmount() {
    if (this.featureInterval) {
      clearInterval(this.featureInterval);
    }
  }

  setActiveFeature = (index) => {
    this.setState({ activeFeature: index });
  }

  render() {
    const { activeFeature, stats, features, services, testimonials } = this.state;

    const styles = {
      root: {
        '--primary-dark': '#010A1A',
        '--secondary-dark': '#002C58',
        '--text-primary': '#ffffff',
        '--text-secondary': '#94a3b8',
        '--box-dark-bg': '#1a2332',
        '--icons-color': '#155EEF',
        '--accent-cyan': '#06b6d4',
        '--accent-blue': '#3b82f6'
      }
    };

    return (
      <div className="min-vh-100" 
           style={{
             backgroundColor: 'var(--primary-dark)',
             color: 'var(--text-primary)',
             fontFamily: 'system-ui, -apple-system, sans-serif'
           }}>
        
        {/* Banner Section */}
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">Remote Concierge Services</h1>
              <p className="hero-subtitle">Virtual front desk support with real-time video interaction, guest management, and access control</p>
            </div>
          </div>
        </section>
        {/* <section className="general-banner py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--primary-dark) 100%)`,
                   minHeight: '50vh',
                   display: 'flex',
                   alignItems: 'center'
                 }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-10">
                <div className="general-content">
                  <h1 className="hero-title display-3 fw-bold mb-4" 
                      style={{
                        fontFamily: 'Orbitron, monospace',
                        color: 'var(--text-primary)',
                        textShadow: '0 0 20px rgba(21, 94, 239, 0.3)'
                      }}>
                    Live Video Monitoring & Security
                  </h1>
                  <p className="hero-subtitle " 
                     style={{ color: 'var(--text-secondary)'}}>
                    Advanced 24/7 surveillance solutions and professional monitoring services
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <button className="btn btn-lg px-4 py-2 d-flex align-items-center gap-2"
                            style={{
                              backgroundColor: 'var(--accent-blue)',
                              border: 'none',
                              borderRadius: '8px',
                              color: 'white',
                              fontWeight: '600'
                            }}>
                      Get Started <ArrowRight className="w-4 h-4" />
                    </button>
                    <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                      <Play className="w-4 h-4" /> Watch Demo
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="position-relative">
                  <div className="d-inline-block p-4 rounded-circle" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '2px solid var(--accent-cyan)',
                         boxShadow: '0 0 30px rgba(6, 182, 212, 0.3)'
                       }}>
                    <Shield className="w-5 h-5" style={{ width: '80px', height: '80px', color: 'var(--accent-cyan)' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Stats Section */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              {stats.map((stat, index) => (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className="text-center p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)',
                         transition: 'transform 0.3s ease'
                       }}
                       onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                       onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}>
                    <h2 className="display-4 fw-bold mb-2" 
                        style={{ color: 'var(--accent-cyan)' }}>
                      {stat.number}
                    </h2>
                    <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Features Section */}
        <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                 Advanced Concierge Capabilities
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                 Where hospitality meets technology for seamless visitor experiences
                </p>
              </div>
            </div>
            <div className="row g-4">
              {features.map((feature, index) => (
                <div key={index} className="col-lg-6 col-md-6">
                  <div className={`p-4 h-100 rounded-3 cursor-pointer transition-all ${
                         activeFeature === index ? 'border-2' : 'border-1'
                       }`}
                       style={{
                         backgroundColor: activeFeature === index ? 'var(--secondary-dark)' : 'var(--box-dark-bg)',
                         borderColor: activeFeature === index ? 'var(--accent-blue)' : 'var(--secondary-dark)',
                         transition: 'all 0.3s ease',
                         cursor: 'pointer'
                       }}
                       onClick={() => this.setActiveFeature(index)}>
                    <div className="d-flex align-items-start gap-3">
                      <div className="p-3 rounded-2 flex-shrink-0" 
                           style={{ 
                             backgroundColor: 'var(--icons-color)', 
                             color: 'white' 
                           }}>
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="fw-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                          {feature.title}
                        </h4>
                        <p className="mb-0" style={{ color: 'var(--text-secondary)' }}>
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-5" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Our Monitoring Services
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Comprehensive security solutions tailored to your needs
                </p>
              </div>
            </div>
            <div className="row g-4">
              {services.map((service, index) => (
                <div key={index} className="col-lg-6">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--primary-dark)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <h4 className="fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                      {service.title}
                    </h4>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      {service.description}
                    </p>
                    <ul className="list-unstyled">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="d-flex align-items-center gap-2 mb-2">
                          <CheckCircle className="w-4 h-4 flex-shrink-0" 
                                      style={{ color: 'var(--accent-cyan)' }} />
                          <span style={{ color: 'var(--text-secondary)' }}>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Client Testimonials
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Trusted by businesses and communities worldwide
                </p>
              </div>
            </div>
            <div className="row g-4">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="col-lg-4">
                  <div className="p-4 h-100 rounded-3" 
                       style={{
                         backgroundColor: 'var(--box-dark-bg)',
                         border: '1px solid var(--secondary-dark)'
                       }}>
                    <div className="d-flex gap-1 mb-3">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4" 
                              style={{ color: '#fbbf24', fill: '#fbbf24' }} />
                      ))}
                    </div>
                    <p className="mb-3" style={{ color: 'var(--text-secondary)' }}>
                      "{testimonial.text}"
                    </p>
                    <div className="border-top pt-3" 
                         style={{ borderColor: 'var(--secondary-dark) !important' }}>
                      <h6 className="fw-bold mb-1" style={{ color: 'var(--text-primary)' }}>
                        {testimonial.name}
                      </h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        {testimonial.company}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-5" 
                 style={{
                   background: `linear-gradient(135deg, var(--secondary-dark) 0%, var(--accent-blue) 100%)`
                 }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
                  Ready to Secure Your Property?
                </h2>
                <p className="lead mb-4" style={{ color: 'var(--text-primary)' }}>
                  Get started with our professional live video monitoring services today
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <button className="btn btn-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Phone className="w-4 h-4" /> Call Now: +1 (403) 992-1672
                  </button>
                  {/* <button className="btn btn-outline-light btn-lg px-4 py-2 d-flex align-items-center gap-2">
                    <Mail className="w-4 h-4" /> Get Free Quote
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info Section */}
        {/* <section className="py-4" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Phone className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>24/7 Support: +1 (555) 123-4567</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <Mail className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>security@company.com</span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <MapPin className="w-5 h-5" style={{ color: 'var(--accent-cyan)' }} />
                  <span style={{ color: 'var(--text-secondary)' }}>Nationwide Coverage</span>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    );
  }
}

export default Concierge;